import { AreaChart } from '@mantine/charts';
import { Stack, Text } from '@mantine/core';

type Point = { label: string; value: number };

/**
 * A small month-by-month trend for a headline card: the last twelve months, no axes to read, with
 * the exact figure on hover. Until there are two months it says so rather than drawing a dot.
 */
export default function TrendChart({
  title,
  points,
  format,
  color,
}: {
  title: string;
  points: readonly Point[];
  format: (value: number) => string;
  color: string;
}) {
  const recent = points.slice(-12);
  return (
    <Stack gap={4} h="100%">
      <Text size="textXs" c="dimmed" ta="right">
        {title}
      </Text>
      {recent.length < 2 ? (
        <Text size="textXs" c="dimmed">
          The trend starts once two months are recorded.
        </Text>
      ) : (
        <AreaChart
          h={150}
          data={recent.map(point => ({ month: point.label, value: point.value }))}
          dataKey="month"
          series={[{ name: 'value', label: title, color }]}
          curveType="linear"
          withDots={false}
          withYAxis={false}
          gridAxis="none"
          valueFormatter={format}
        />
      )}
    </Stack>
  );
}
